import React, { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';
import { FiX, FiFlag } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function ReportModal({ isOpen, onClose, post }) {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setSuccess(false);
      setMsg('');
      setEmail('');
      setReason('');
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!post) return;
    setLoading(true);
    setMsg('');

    try {
      const { error: dbError } = await supabase.from('reports_1715000000').insert([{
        post_id: post.id,
        email,
        reason
      }]);

      if (dbError) throw dbError;
      setSuccess(true);
    } catch (error) {
      setMsg(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-retro-brown/80 p-4 backdrop-blur-sm">
      <div className="bg-retro-cream p-8 md:p-10 rounded-3xl border-4 border-retro-brown shadow-retro w-full max-w-lg relative">
        <button onClick={onClose} className="absolute top-6 right-6 text-retro-brown hover:text-red-500 transition-colors bg-white border-2 border-retro-brown rounded-full p-2 shadow-retro-sm active:translate-y-0.5 active:shadow-retro-active">
          <SafeIcon icon={FiX} className="text-2xl font-bold" />
        </button>

        {success ? (
          <div className="text-center py-10">
            <div className="w-20 h-20 bg-retro-yellow border-4 border-retro-brown rounded-full mx-auto flex items-center justify-center shadow-retro mb-6">
              <SafeIcon icon={FiFlag} className="text-4xl text-retro-brown" />
            </div>
            <h2 className="font-display text-4xl text-retro-brown mb-4 uppercase tracking-wider">REPORT SENT</h2>
            <p className="text-xl font-bold text-retro-brown/80 mb-8">Our admin team will review this listing shortly.</p>
            <button onClick={onClose} className="bg-retro-teal text-white py-3 px-8 rounded-xl font-display text-xl tracking-wider border-4 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-1 active:translate-y-1 active:shadow-retro-active transition-all">
              CLOSE
            </button>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-red-100 border-4 border-retro-brown rounded-full flex items-center justify-center shadow-retro-sm">
                <SafeIcon icon={FiFlag} className="text-2xl text-red-600" />
              </div>
              <h2 className="font-display text-4xl text-retro-brown uppercase tracking-wider drop-shadow-[2px_2px_0_#F4D03F]">REPORT LISTING</h2>
            </div>
            
            <form onSubmit={handleSubmit} className="flex flex-col gap-6 text-left">
              <div>
                <label className="block font-bold text-retro-brown mb-2 text-lg">Your Email *</label>
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com" 
                  className="w-full p-4 bg-white border-4 border-retro-brown rounded-xl focus:outline-none focus:ring-4 focus:ring-retro-blue font-bold text-retro-brown shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]"
                  required 
                />
              </div>

              <div>
                <label className="block font-bold text-retro-brown mb-2 text-lg">Why are you reporting this? *</label>
                <textarea 
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Please provide details..." 
                  rows="4"
                  className="w-full p-4 bg-white border-4 border-retro-brown rounded-xl focus:outline-none focus:ring-4 focus:ring-retro-blue font-bold text-retro-brown shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] resize-none"
                  required 
                />
              </div>
              
              <button 
                type="submit" 
                disabled={loading} 
                className="w-full bg-red-500 text-white py-4 rounded-xl font-display text-2xl tracking-wider border-4 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-1 active:translate-y-1 active:shadow-retro-active transition-all mt-4 disabled:opacity-50"
              >
                {loading ? 'SUBMITTING...' : 'SUBMIT REPORT'}
              </button>

              {msg && (
                <div className={`text-base font-bold text-center p-4 border-4 border-retro-brown rounded-xl shadow-retro-sm ${msg.toLowerCase().includes('error') ? 'bg-red-100 text-red-700' : 'bg-retro-lime text-retro-brown'}`}>
                  {msg}
                </div>
              )}
            </form>
          </>
        )}
      </div>
    </div>
  );
}